import List from "@/components/list";
import router from "@/router";
import store from "@/store";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const flatPermissions = store.getters.flatPermissions;
  const deleteClass = listeners["deleteClass"] || function () { };
  const publishClass = listeners["publishClass"] || function () { };
  const permissionList = ['onlineClass:update', 'onlineClass:delete', 'onlineClass:publish', 'enroll:pageStudent', 'group:page', "teachingPlan:info", "class:notice:page", "fileLibrary:page"]

  // 到班级详情
  function goClassDetail(onlineClass) {
    router.push({
      path: "onlineClass/detail",
      query: { id: onlineClass.uuid },
    });
  }

  // 编辑班级
  function editClass({ uuid, classStatus }) {
    router.push({ path: "/onlineClass/add", query: { id: uuid, status: classStatus } });
  }

  // 学员管理
  function studentsManage(onlineClass) {
    router.push({
      path: "onlineClass/students",
      query: {
        id: onlineClass.uuid,
        status: onlineClass.classStatus,
        isAttachment: onlineClass.isAttachment
      },
    });
  }
  // 分组管理
  function goClassGroup(onlineClass) {
    router.push({
      path: "onlineClass/classGroup",
      query: { id: onlineClass.uuid, className: onlineClass.className },
    });
  }

  // 教学管理-教学计划
  function teachingPlan(onlineClass) {
    router.push({
      path: "onlineClass/teaching",
      query: { id: onlineClass.uuid },
    });
  }

  // 班级公告
  function noticeList(onlineClass) {
    router.push({
      path: "onlineClass/classNotice",
      query: { id: onlineClass.uuid },
    });
  }

  // 资源库列表
  function fileLibraryList(exam) {
    router.push({
      path: "onlineClass/fileLibrary",
      query: { id: exam.uuid },
    });
  }

  const Deal = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    const dealConf = [
      ["icon-edit", "编辑", () => editClass(onlineClass), "onlineClass:update"],
      ["icon-delete", "删除", () => { deleteClass(onlineClass.uuid) }, "onlineClass:delete"],
      [
        onlineClass.publishStatus === 0 ? "icon_fabu" : "icon_fabu-disable",
        "发布",
        onlineClass.publishStatus === 0
          ? () => {
            publishClass(onlineClass);
          }
          : () => { },
        "onlineClass:publish",
      ],
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
        <el-tooltip
          content="学员管理"
          placement="top"
          v-permission="enroll:pageStudent"
        >
          <i
            class="icon-student"
            onClick={() => studentsManage(onlineClass)}
          ></i>
        </el-tooltip>
        {/* <el-tooltip
          content="分组管理"
          placement="top"
          v-permission="group:page"
        >
          <i
            class="icon-class-group"
            onClick={() => goClassGroup(onlineClass)}
          ></i>
        </el-tooltip> */}
        <el-tooltip
          content="教学管理"
          placement="top"
          v-permission="teachingPlan:info"
        >
          <i
            class="icon-teaching"
            onClick={() => teachingPlan(onlineClass)}
          ></i>
        </el-tooltip>
        {/* <el-tooltip
          content="班级公告"
          placement="top"
          v-permission="class:notice:page"
        >
          <i
            class="icon-class-notice"
            onClick={() => noticeList(onlineClass)}
          ></i>
        </el-tooltip> */}
        {/* <el-tooltip
          content="资源库"
          placement="top"
          v-permission="fileLibrary:page"
        >
          <i
            class="icon-resource"
            onClick={() => fileLibraryList(onlineClass)}
          ></i>
        </el-tooltip> */}
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
      ? vo.row.classStatusName
      : "--";
    return <span>{classStatusName}</span>;
  };

  const ClassName = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goClassDetail(onlineClass)}>
        {onlineClass.className}
      </div>
    );
  }
  const EnrollTime = ({ props: { vo } }) => {
    const onlineClass = vo.row;
    return (
      <span>{onlineClass.trainStartTime}~{onlineClass.trainEndTime}</span>
    );
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "班级名称",
      prop: "className",
      minWidth: "400",
      render: (vo) => <ClassName vo={vo} />,
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "180",
      showOverflowTooltip: true,
    },
    // {
    //   label: "班级类型",
    //   prop: "trainTypeName",
    //   width: "100",
    //   showOverflowTooltip: true,
    // },
    // {
    //   label: "计划人数",
    //   prop: "planStuNum",
    //   width: "80",
    //   showOverflowTooltip: true,
    // },
    {
      label: "报名情况",
      prop: "enrollSituation",
      minWidth: "110",
      showOverflowTooltip: true,
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|限制(人)</span>
          </div>
        )
      }
    },
    {
      label: "班级状态",
      prop: "classStatusName",
      minWidth: "80",
      render: (vo) => <ClassStatusName vo={vo} />,
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: "80",
      showOverflowTooltip: true,
    },
    // {
    //   label: "党校同步状态",
    //   prop: "classPushStatusName",
    //   minWidth: "150",
    //   showOverflowTooltip: true,
    // },
    // {
    //   label: "上次同步时间",
    //   prop: "classPushTime",
    //   minWidth: "150",
    //   showOverflowTooltip: true,
    // },
    {
      label: "培训时间",
      minWidth: "180",
      showOverflowTooltip: true,
      render: (vo) => <EnrollTime vo={vo} />
    },
    {
      label: "结业率",
      prop: "graduationRate",
      minWidth: "80"
    },
  ];
  let iconNum = 0;
  permissionList.forEach(x => {
    if (flatPermissions.includes(x)) {
      iconNum += 1;
    }
  });
  if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: String(iconNum * 30 + 10 > 130 ? 130 : iconNum * 30 + 10),
      render: vo => <Deal vo={vo} />
    })
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
